import { ReactNode, useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { useWebshopAuth } from "@/contexts/WebshopAuthContext";
import { WebshopLoadingSkeleton } from "./templates/minimalist/WebshopLoadingSkeleton";

export function ProtectedWebshopRoute({ children }: { children: ReactNode }) {
  const { customer, loading } = useWebshopAuth();
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !customer) {
      navigate(`/shop/${slug}/login`, { replace: true });
    }
  }, [customer, loading, navigate, slug]);

  if (loading) return <WebshopLoadingSkeleton />;
  if (!customer) return null;

  return <>{children}</>;
}
